import React from 'react';
import { Tooltip, Icon } from 'components';

const AppointmentUpdateTooltip: React.FC = () => (
    <Tooltip
      placement="right"
      title="Turning on this notification enables you to receive updates about the property communicated by the listing management team."
    >
      <span>
        <Icon type="antdInfoCircleOutlined" offset={[8, 24]} />
      </span>
    </Tooltip>
  );

export default AppointmentUpdateTooltip;
